/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function ($) {
  'use strict';
  /**
   * Вид ответов и комментариев
   */
  app.ClaimItemResponseView = app.View.extend({
    events: {
      'click .js-add-response': 'addForm'
    },
    template: '#claim-item-response-template',

    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate(this.template);
    },

    render: function (replace) {
      if (this.childViews.claimCommentForm) {
        this.childViews.claimCommentForm.remove();
      }
      var claimItemComments = this.model.get('claim_item_response_comments') || [],
        newElement = $(this.template({
          model: this.model,
          comments: claimItemComments
        }));
      if (replace) {
        this.$el.replaceWith(newElement);
      }
      this.setElement(newElement);
      return this;
    },

    /**
     *  Показ формы
     */
    addForm: function (e) {
      var target =  this.$(e.currentTarget),
        commentId = target.data('response-comment'),
        formView = new app.ClaimItemResponseCommentFormView({
          model: new app.Model()
        });
      formView.model.urlRoot = app.entryScriptName + '/api/v3/claim-item-response-comment';
      formView.model.set('claim_item_response_id', commentId);
      target.addClass('not_display');
      this.$el.append(formView.render().el);
      this.childViews.claimCommentForm = formView;
      this.listenToOnce(formView, 'claim-item-view-saved', this.afterSave);
      this.listenToOnce(formView, 'claim-item-cancel-form', this.cancelForm);
    },
    /**
     * Подготовка модели к рендеру
     * @param model
     */
    afterSave: function (model) {
      if (model instanceof app.Model) {
        var collection = this.model.get('claim_item_response_comments');
        if (!(collection instanceof app.Collection)) {
          collection = new app.Collection();
          this.model.set('claim_item_response_comments', collection);
        }
        collection.add(model);
      }
      this.render(true);
    },
    /**
     * Отмена формы
     */
    cancelForm: function () {
      $('.js-add-response').removeClass('not_display');
    }

  });
})(jQuery);

}.call(window));